/**
 * SubcribeFilterItems
 * 
 * @Author: Focci
 * @Date: 2023-08-05 18:26:37
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-05 18:26:37
 */

'use client'

import PropTypes from 'prop-types'
import clsx from 'clsx'
import CloseIcon from '@mui/icons-material/Close'
import { useCallback, useEffect, useState } from 'react'
import { ButtonBase } from '@comp/material'
import { useTranslations } from 'next-intl'
import { filter, omit } from 'lodash-es'
import { getSubcribeOptions } from './lib'

export function SubcribeItem({
  option = {},
  closable = true,
  className = 'text-white bg-primary rounded-full',
  onClick = () => {}
}) {
  return (
    <div className={clsx(['flex items-center h-6 px-2 ', className])}>
      <span>{option.label}</span>
      {closable && option.closable !== false && (
        <ButtonBase 
          className="rounded-full p-1 -mr-1 ml-1"
          onClick={onClick}
        >
          <CloseIcon sx={{ fontSize: '.7rem' }} />
        </ButtonBase>
      )}
    </div>
  )
}

export function SubcribeItemOutline({
  ...props
}) {
  return (
    <SubcribeItem 
      className="border border-solid border-gray text-gray rounded-sm"
      {...props} 
    />
  )
}

export default function SubcribeFilterItems({
  type = '',
  variant = 'full',
  closable = true,
  searchParam = {},
  onChange = () => {}
}) {
  const tm = useTranslations('menu')
  const ts = useTranslations('search')
  const [options, setOptions] = useState([])
  const [params, setParams] = useState(searchParam)
  
  const Component = variant === 'full' ? SubcribeItem : SubcribeItemOutline
  
  const handleClick = useCallback((option, index) => {
    const opt = omit(params, [option.prop])
    setOptions((prev) => filter(prev, (_opt, i) => i !== index))
    setParams(opt)
    onChange(opt)
  }, [onChange, params])

  useEffect(() => {
    setOptions(
      getSubcribeOptions({ type, searchParam, tm, ts })
    )
  }, [searchParam, tm, ts, type])

  return options.map((option, index) => (
    <Component 
      key={option.prop} 
      closable={closable} 
      option={option}
      onClick={() => handleClick(option, index)}
    />
  ))
}

SubcribeFilterItems.propTypes = {
  type: PropTypes.string,
  variant: PropTypes.oneOf(['full', 'outline']),
  searchParam: PropTypes.object,
}
